import { error } from '@sveltejs/kit'

import { parseMarkdown } from '../../parseMarkdown'

export async function load({ params, fetch }) {
  const res = await fetch(`/_posts/${params.post}.md`)
  if (res.ok) {
    const content = await res.text()

    return parseMarkdown(params.post, content)
  }

  // not found otherwise
  error(404)
}
